import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router";
import { ReactSVG } from "react-svg";
import {
  CancelIconBlackWithoutPadding,
  FlagIconBlack,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { Button } from "../../../../stories/Button/Button";
import PaymentMethodCard from "../../../../stories/PaymentMethodCard/PaymentMethodCard";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import classes from "./performanceEvaluationMobile.module.css";

function PerformanceEvaluationMobile() {
  const history = useHistory();
  const [feedback, setFeedback] = useState('Vitae fames a consectetur ut adipiscing vestibulum, auctor donec facilisi. Arcu sed facilisi egestas facilisi cras egestas mauris aenean nisl. Massa, leo felis, vel donec morbi dignissim bibendum a ac. Sit mi, magna semper ut. Congue justo, sapien duis dui suspendisse.Vitae fames a consectetur ut adipiscing vestibulum, auctor donec facilisi. Arcu sed facilisi egestas facilisi cras egestas mauris aenean nisl. Massa, leo felis, vel donec morbi dignissim bibendum a ac. Sit mi, magna semper ut. Congue justo, sapien duis dui suspendisse.')
  const [isUpdating, setIsUpdating] = useState(false)
  const [isUpdated, setIsUpdated] = useState(false)

  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <ReactSVG
          src={CancelIconBlackWithoutPadding}
          beforeInjection={(svg) => svg.classList.add(classes.crossIcon)}
          onClick={() => history.goBack()}
        />
        <h6 style={{ ...Fonts.b3 }}>Lesson Details</h6>
      </div>
      <Container fluid className={classes.container}>
        <Row className={`g-0 ${classes.row}`}>
          <Col md={12}>
            <Row className="g-0">
              <Col md={12}>
                <h3
                  style={{
                    ...Fonts.h2,
                    fontSize: "26px",
                    lineHeight: "32px",
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  1-on-1 Tennis Lesson with Michael Baumgardner
                </h3>
              </Col>
              <Col md={12} className={`${[classes.mt48].join(" ")}`}>
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Performance evaluation
                </h5>
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                  className={classes.mt8}
                >
                  Vitae fames a consectetur ut adipiscing vestibulum, auctor
                  donec facilisi. Arcu sed facilisi egestas facilisi cras
                  egestas mauris aenean nisl. Massa, leo felis, vel donec morbi
                  dignissim bibendum a ac.
                </p>
              </Col>
              {/* Feedback */}
              <Col md={12} className={classes.mt32}>
                <h5 style={{ ...Fonts.h5 }} className={classes.mb16}>Your’s feedback of the lesson</h5>
                {isUpdated ?
                  <div className={classes.feedbackBox} style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}>
                    <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>{feedback}</p>
                  </div>
                  :
                  <TextArea state={feedback} setter={setFeedback} disabled={isUpdated} />}
                {!isUpdated && <div className={[classes.mt16, classes.btnsBox].join(" ")}>
                  <Button label={'Cancel'} className={classes.cancelBtn} primary={false} size={'Medium'} />
                  <Button label={'Update'} primary={true} size={'Medium'} className={classes.updateBtn} customStyle={{ marginLeft: '8px' }} onClick={() => {
                    setIsUpdating(true)
                    setTimeout(() => {
                      setIsUpdated(true)
                      setIsUpdating(false)
                    }, 2000)

                  }} />
                </div>}
              </Col>

              <Col md={12} className={classes.mt48}>
                <PaymentMethodCard
                  data={{
                    type: "master",
                    title: "Paid with card ending",
                    number: ".... 0084",
                    description: "This is your default payment method",
                    date: "Aug 12, 2021",
                    time: "02:06pm",
                    amount: "75",
                  }}
                  isDone={true}
                />
              </Col>
            </Row>
          </Col>
          <Col md={12} className={classes.alignEnd}>
            <div className={classes.btns}>
              <Button primary={false} icon={FlagIconBlack} size={"Large"} />
              <Button primary={true} label={"Leave a review"} size={"Large"} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PerformanceEvaluationMobile;
